import { AnalyticsContext } from '../AnalyticsContext';
import { AnalyticsDispatcher } from '../AnalyticsDispatcher';
export function withContext(analyticsContext) {
    return function (dispatcher) {
        return new AnalyticsDispatcher(dispatcher.dispatch.bind(dispatcher), analyticsContext instanceof AnalyticsContext
            ? analyticsContext
            : new AnalyticsContext(analyticsContext.Scopes, analyticsContext.ExtraData, analyticsContext.MetaData, analyticsContext.Identities, analyticsContext.Filters));
    };
}
//# sourceMappingURL=withContext.js.map